import { useState } from "react";

export default function useStateLocalStorage<T>(
   key: string,
   initialValue: T
): [T, (value: T) => void] {
   const [state, setInternalState] = useState<T>(getItem(key, initialValue));

   function getItem(key: string, initialValue: T): T {
        try {
            const value = localStorage.getItem(key);
            if (value === null || value === undefined || value === "undefined") {
                localStorage.removeItem(key);
                return initialValue;
            }
            const parsedValue = JSON.parse(value);
            if (parsedValue === null || parsedValue === undefined || parsedValue === "undefined") {
                localStorage.removeItem(key);
                return initialValue;
            }
            return parsedValue;
        } catch {
            return initialValue;
        }
   }

   const setState = (value: T) => {
       if (value === undefined || value === null || value === "undefined") {
           localStorage.removeItem(key);
           setInternalState(value);
       } else {
            localStorage.setItem(key, JSON.stringify(value));
            setInternalState(value);
       }
   };

   return [state, setState];
}